import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplyComponent } from './supply.component';
import { RouterModule, Routes } from '@angular/router';
import {AppMainComponent} from '../../app.main.component';
import {AuthGuardService} from '../../guards/auth-guard.service';


const routes: Routes = [
    {path: 'supply', redirectTo: 'supply/list', pathMatch: 'full'},
    {
        path: 'supply', component: AppMainComponent,
        children: [
            {path: 'list', component: SupplyComponent, canActivate: [AuthGuardService]},
        ]
    },
];

@NgModule({
  declarations: [
    SupplyComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'}),
  ]
})
export class SupplyModule { }
